import { render, staticRenderFns } from "./GroupClasses.vue?vue&type=template&id=fc359eba&scoped=true"
import script from "./GroupClasses.vue?vue&type=script&lang=js"
export * from "./GroupClasses.vue?vue&type=script&lang=js"
import style0 from "./GroupClasses.vue?vue&type=style&index=0&id=fc359eba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc359eba",
  null
  
)

export default component.exports